import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';
( function( app ) {
  const COMPONENT = {
    init: function() {
      if ( $( '.reg__splide' ).length ) {
        $( '.reg__splide' ).each( function( index, element ) {
          const slider = new Splide( $( element )[0], {
            type: 'loop',
            drag: 'free',
            gap: '8px',
            arrows: false,
            autoWidth: true,
            pagination: false,
            autoScroll: {
              speed: .75,
              pauseOnFocus: false,
              pauseOnHover: false,
            },
          } );
          slider.mount( {AutoScroll} );
        } );
      }

      if ( $( '.graphic_slide__splide' ).length ) {
        $( '.graphic_slide__splide' ).each( function( index, element ) {
          const slider = new Splide( $( element )[0], {
            type: 'fade',
            drag: 'free',
            gap: '1rem',
            arrows: false,
            perPage: 1,
            perMove: 1,
            pagination: false,
            breakpoints: {
              768: {
                destroy: true,
              },
            },
          } );
          slider.mount( );
          $( '.reg__splide-tab:first-of-type' ).addClass( 'is-active' );

          const cardCount = $( '.reg__splide-tab' ).length;
          let nextTab = 0;
          let goToSlide;

        function startInterval() {// eslint-disable-line
            goToSlide = setInterval( function progressBar() {
              const activeTab = $( '.reg__splide-tab.is-active' ).data( 'splide' );
              nextTab = ( activeTab + 1 ) % cardCount;
              slider.go( nextTab );
            }, 3000 );
          }

          startInterval();

          $( '.reg__splide-tab' ).on( 'click', function() {
            if ( $( this ).hasClass( 'is-active' ) ) return;
            clearInterval( goToSlide );
            const goToSplide = parseInt( $( this ).data( 'splide' ), 10 );
            if ( !isNaN( goToSplide ) ) {
              slider.go( goToSplide );
              startInterval();
            }
          } );

          slider.on( 'move', function( newIndex, prevIndex, destIndex ) {
            $( '.reg__splide-tab' ).removeClass( 'is-active' );
            $( `.reg__splide-tab[data-splide="${destIndex}"]` ).addClass( 'is-active' );
          } );
        } );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'rotating-eductation-graphic', COMPONENT );
} )( app );
